export default __webpack_public_path__ + "assets/images/509-small.webp";